import * as React from 'react';
import * as Clients from '../../client/ApiClient';
import Toolbar from '../basic/Toolbar';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import ClientMergePage from './Merge';
import AcquisitionPage from './Acquisition';
import CustomersPage from './Customers';
import PoliciesPage from './Policies';
import ContactsPage from './Contacts';
import ActivitiesPage from './Activities';
import MiniDashPage from './MiniDashboard';

interface IAdditionalDataPageState {
    types: { description: string }[]
    selected: string
    options: { [key: string]: Clients.ConversionOptionValueModel } | undefined;
}

interface AdditionalDataProps extends RouteComponentProps<{
    conversionId: string
}> { 
    renderMode: string,
    customersFile: boolean,
    policiesFile: boolean,
    ContactsFile: boolean,
    ActivitiesFile: boolean,
    currentUser: Clients.IUserLoginDetailsModel | undefined,
}

class AdditionalDataPage extends React.Component<AdditionalDataProps, IAdditionalDataPageState>{
    private readonly fileUploadClient: Clients.FileUploadClient = new Clients.FileUploadClient();
    private options: Clients.ConversionOptionsClient = new Clients.ConversionOptionsClient();
    private types: { key: number, description: string }[] = [];
    private selected: string = '';

    constructor(props: Readonly<AdditionalDataProps>) {
        super(props)
        this.state = {
            types: [],
            selected: "",
            options: undefined,
        }
    }

    componentDidMount() {
        //this.fileUploadClient.getAllTypes()
        //    .then((response) => {
        //        console.log(response)
        //    })
        this.setState({ types: this.types });
        this.setState({ selected: this.selected });
        this.getOptions();
    }

    getOptions = () => {
        this.options.get(this.props.match.params.conversionId)
            .then(values => {
                const options = values!.reduce(
                    (result, current) => ({ ...result, [current.id!]: current, }), {});
                this.setState({ options });
            })
            .catch(e => {
                console.log(e)
            })
    }

    handleCompanyTypeChange(event: React.ChangeEvent<HTMLSelectElement>) {
        this.selected = event.target.value
        this.setState({ selected: this.selected })
    }

    setTypes() {
        if (this.props.renderMode !== "Mini") {
            this.types = [
                {
                    key: 1, description: "Select Additional Data Type"
                },
                {
                    key: 2, description: "Client Acquisition Code"
                },
                {
                    key: 3, description: "Client Merge"
                }
            ]
            if (this.selected.length === 0) { this.selected = "Select Additional Data Type"; }
        } else if (this.props.renderMode === 'Mini' && this.props.customersFile && this.props.policiesFile && !this.props.ContactsFile && !this.props.ActivitiesFile) {
            this.types = [
                {
                    key: 1, description: "Select File Upload Type"
                },
                {
                    key: 2, description: "Customers File"
                },
                {
                    key: 3, description: "Policies File"
                }
            ]
            if (this.selected.length === 0) { this.selected = "Select File Upload Type"; }
        } else if (this.props.renderMode === 'Mini' && this.props.customersFile && !this.props.policiesFile && !this.props.ContactsFile && !this.props.ActivitiesFile) {
            this.types = [
                {
                    key: 1, description: "Select File Upload Type"
                },
                {
                    key: 2, description: "Customers File"
                }
            ]
            if (this.selected.length === 0) { this.selected = "Select File Upload Type"; }
        } else if (this.props.renderMode === 'Mini' && this.props.customersFile && !this.props.policiesFile && this.props.ContactsFile && !this.props.ActivitiesFile) {
            this.types = [
                {
                    key: 1, description: "Select File Upload Type"
                },
                {
                    key: 2, description: "Customers File"
                },
                {
                    key: 3, description: "Contacts File"
                }
            ]
            if (this.selected.length === 0) { this.selected = "Select File Upload Type"; }
        } else if (this.props.renderMode === 'Mini' && this.props.customersFile && !this.props.policiesFile && !this.props.ContactsFile && this.props.ActivitiesFile) {
            this.types = [
                {
                    key: 1, description: "Select File Upload Type"
                },
                {
                    key: 2, description: "Customers File"
                },
                {
                    key: 3, description: "Activities File"
                }
            ]
            if (this.selected.length === 0) { this.selected = "Select File Upload Type"; }
        } else if (this.props.renderMode === 'Mini' && this.props.customersFile && this.props.policiesFile && this.props.ContactsFile && !this.props.ActivitiesFile) {
            this.types = [
                {
                    key: 1, description: "Select File Upload Type"
                },
                {
                    key: 2, description: "Customers File"
                },
                {
                    key: 3, description: "Policies File"
                },
                {
                    key: 4, description: "Contacts File"
                }
            ]
            if (this.selected.length === 0) { this.selected = "Select File Upload Type"; }
        } else if (this.props.renderMode === 'Mini' && this.props.customersFile && this.props.policiesFile && !this.props.ContactsFile && this.props.ActivitiesFile) {
            this.types = [
                {
                    key: 1, description: "Select File Upload Type"
                },
                {
                    key: 2, description: "Customers File"
                },
                {
                    key: 3, description: "Policies File"
                },
                {
                    key: 4, description: "Activities File"
                }
            ]
            if (this.selected.length === 0) { this.selected = "Select File Upload Type"; }
        } else if (this.props.renderMode === 'Mini' && this.props.customersFile && !this.props.policiesFile && this.props.ContactsFile && this.props.ActivitiesFile) {
            this.types = [
                {
                    key: 1, description: "Select File Upload Type"
                },
                {
                    key: 2, description: "Customers File"
                },
                {
                    key: 3, description: "Contacts File"
                },
                {
                    key: 4, description: "Activities File"
                }
            ]
            if (this.selected.length === 0) { this.selected = "Select File Upload Type"; }
        } else if (this.props.renderMode === 'Mini' && this.props.customersFile && this.props.policiesFile && this.props.ContactsFile && this.props.ActivitiesFile) {
            this.types = [
                {
                    key: 1, description: "Select File Upload Type"
                },
                {
                    key: 2, description: "Customers File"
                },
                {
                    key: 3, description: "Policies File"
                },
                {
                    key: 4, description: "Contacts File"
                },
                {
                    key: 4, description: "Activities File"
                }
            ]
            if (this.selected.length === 0) { this.selected = "Select File Upload Type"; }
        } else {
            this.types = [
                {
                    key: 1, description: "Select File Upload Type"
                }
            ]
            this.selected = "Select File Upload Type";
        }
    }

    public render() {
        this.setTypes();
        return (
            <>
                {this.props.renderMode === 'Mini' && <MiniDashPage currentUser={this.props.currentUser} options={this.state.options} getOptions={() => this.getOptions()} />}
                <h3 className='mapping-body-header'>File Upload</h3>
                <Toolbar>
                    <div className="moveLeft">
                        <select
                            className="custom-select"
                            name="fileType"
                            value={this.selected}
                            onChange={event => this.handleCompanyTypeChange(event)}
                        >
                            {this.types.map((type) => (
                                <option
                                    key={type.key}
                                    value={type.description}
                                >
                                    {type.description}
                                </option>
                            ))}
                        </select>
                    </div>
                </Toolbar>
                {this.selected === 'Client Merge' && <ClientMergePage />}
                {this.selected === 'Client Acquisition Code' && <AcquisitionPage />}
                {this.selected === 'Customers File' && <CustomersPage getOptions={() => this.getOptions()} />}
                {this.selected === 'Policies File' && <PoliciesPage getOptions={() => this.getOptions()} />}
                {this.selected === 'Contacts File' && <ContactsPage getOptions={() => this.getOptions()} />}
                {this.selected === 'Activities File' && <ActivitiesPage getOptions={() => this.getOptions()} />}
            </>
        )
    }
}

export default withRouter(AdditionalDataPage)